<div class="col-md-12">
    <h4 class="text-center">{{habitacion.habitacion}}</h4>
    <span class="text-white text-center">{{new Date()}}</span>
</div>
<form autocomplete="off" @submit.prevent="true">
    <div class="row">
        <p>Información del Paciente Actual en la Habitación:</p>
        <div class="col-md-6">
            <div class="mb-3">
                <label for="nombre" class="form-label">Nombre Completo: *</label>
                <InputText id="nombre" autocomplete="off" type="text" class="vue-input" placeholder="Nombre Completo"
                    v-model="habitacion.nombrePaciente" @input="habitacion.nombrePaciente = $event.target.value.toUpperCase()" requiered />
            </div>
        </div>
        <div class="col-md-6">
            <div class="mb-3">
                <label for="edad" class="form-label">Edad: *</label>
                <InputNumber id="edad" class="vue-input" v-model="habitacion.edad" inputId="integeronly" suffix=" años"
                    :min="0" :max="100" />
            </div>
        </div>
        <div class="col-md-6">
            <div class="mb-3">
                <label for="dir" class="form-label">Dirección: *</label>
                <InputText id="dir" autocomplete="off" type="text" class="vue-input" placeholder="Domicilio"
                    v-model="habitacion.direccion" @input="habitacion.direccion = $event.target.value.toUpperCase()" requiered />
            </div>
        </div>
        <div class="col-md-6">
            <div class="mb-3">
                <label for="tel" class="form-label">Telefono: *</label>
                <InputText id="tel" autocomplete="off" type="InputNumber" class="vue-input" placeholder="Número Telefonico"
                    v-model="habitacion.tel" requiered />
            </div>
        </div>
        <div class="col-md-6">
            <div class="mb-3">
                <label for="email" class="form-label">Correo: *</label>
                <InputText id="email" autocomplete="off" type="email" class="vue-input" placeholder="Correo electronico"
                    v-model="habitacion.correo" requiered />
            </div>
        </div>
        <!--
        <div class="col-md-6">
            <div class="mb-3">
                <label for="fn" class="form-label">Fecha de nacimiento *</label>
                <Calendar id="fn" class="vue-input" v-model="fecha3" dateFormat="dd/mm/yy" showIcon />
            </div>
        </div>
        -->
        <div class="col-md-6">
            <div class="mb-3">
                <label for="fn" class="form-label">Fecha de nacimiento *</label>
                <input id="fn" class="vue-input form-control" style="height: 50px;" type="date" v-model="fecha3" autocomplete="off" />
            </div>
        </div>
        <div class="col-md-6">
            <div class="mb-3">
                <label for="sexo" class="form-label">Sexo: *</label>
                <Dropdown id="sexo"
                    class="vue-input"
                    v-model="habitacion.sexo"
                    :options="[{label:'MASCULINO', value:'MASCULINO'}, {label:'FEMENINO', value:'FEMENINO'}]"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Seleccione sexo"
                    required
                />
            </div>
        </div>
        <div class="col-md-6">
            <div class="mb-3">
                <label for="edoCivil" class="form-label">Estado Civil: *</label>
                <Dropdown id="edoCivil"
                    class="vue-input"
                    v-model="habitacion.estadoCivil"
                    :options="[
                        {label:'SOLTERO(A)', value:'SOLTERO(A)'},
                        {label:'CASADO(A)', value:'CASADO(A)'},
                        {label:'DIVORCIADO(A)', value:'DIVORCIADO(A)'},
                        {label:'VIUDO(A)', value:'VIUDO(A)'},
                        {label:'UNIÓN LIBRE', value:'UNIÓN LIBRE'}
                    ]"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Seleccione estado civil"
                    required
                />
            </div>
        </div>
        <!--
        <div class="col-md-6">
            <div class="mb-3">
                <label for="ingre" class="form-label">Fecha y Hora de Ingreso: *</label>
                <Calendar id="ingre" class="vue-input" v-model="fecha1" dateFormat="dd/mm/yy" showIcon showTime
                    hourFormat="12" />
            </div>
        </div>
        -->
        <div class="col-md-6">
            <div class="mb-3">
                <label for="ingre" class="form-label">Fecha y Hora de Ingreso: *</label>
                <input id="ingre" class="vue-input form-control" style="height: 50px;" type="datetime-local" v-model="fecha1" autocomplete="off" />
            </div>
        </div>
        <!--
        <div class="col-md-6">
            <div class="mb-3">
                <label for="egre" class="form-label">Fecha y Hora de Egreso:</label>
                <Calendar id="egre" class="vue-input" v-model="fecha2" dateFormat="dd/mm/yy" showIcon showTime
                    hourFormat="12" />
            </div>
        </div>
        -->
        <div class="col-md-6">
            <div class="mb-3">
                <label for="egre" class="form-label">Fecha y Hora de Egreso:</label>
                <input id="egre" class="vue-input form-control" style="height: 50px;" type="datetime-local" v-model="fecha2" autocomplete="off" />
            </div>
        </div>
        <div class="col-md-6">
            <div class="mb-3">
                <label for="nombreMed" class="form-label">Médicos Tratantes: *</label>
              <AutoComplete 
                id="nombreMed"
                v-model="habitacion.medicoTratante"
                :suggestions="doctoresFilter"
                optionLabel="nombre"
                placeholder="Selecciona los doctores"
                class="vue-input w-100"
                multiple
                @complete="search"
                />
            </div>
        </div>

        <div class="col-md-6">
            <div class="mb-3">
                <label for="nombreEn" class="form-label">Nombre del Enfermero:</label>
                <AutoComplete id="nombreEn" v-model="habitacion.nombreEnfermero" @input="habitacion.nombreEnfermero = $event.target.value.toUpperCase()" optionLabel="nombre" dropdown
                    class="vue-input" placeholder="Nombre del Enfermero" :suggestions="enfermerosFilter"
                    @complete="search2" requiered />
            </div>
        </div>
        <div class="col-md-6">
            <div class="mb-3">
                <label for="diagnoi" class="form-label">Impresión Diagnóstica: *</label>
                <AutoComplete 
                    id="diag"
                    v-model="habitacion.diagnosticoi" 
                    optionLabel="nombre"  
                    class="vue-input" 
                    placeholder="Diagnóstico" 
                    :suggestions="diagnosticosFilter" 
                    @complete="search3"
                    multiple
                    :field="'nombre'" 
                    :forceSelection="true"
                />
                <!-- <InputText id="diagnoi" autocomplete="off" type="text" class="vue-input" placeholder="Dx."
                    v-model="habitacion.diagnosticoi" requiered /> -->
            </div>
        </div>
        <div class="col-md-6">
            <div class="mt-4 mb-3">
                <label for="dia" class="ml-2 me-2" v-show="habitacion.isdiabetico">Diabético: SI</label>
                <label for="dia" class="ml-2 me-2" v-show="!habitacion.isdiabetico">Diabético: NO</label>
                <Checkbox v-model="habitacion.isdiabetico" :binary="true" />
            </div>
            <div class="mb-3">
                <label for="hiper" class="ml-2 me-2" v-show="habitacion.ishipertenso">Hipertenso: SI</label>
                <label for="hiper" class="ml-2 me-2" v-show="!habitacion.ishipertenso">Hipertenso: NO</label>
                <Checkbox v-model="habitacion.ishipertenso" :binary="true" />
            </div>
        </div>
        <div class="col-md-6">
            <div class="mb-3">
                <label for="isalergia" class="ml-2 me-2" v-show="habitacion.isalergia">Alergía a Medicamento o Alimento:
                    SI</label>
                <label for="isalergia" class="ml-2 me-2" v-show="!habitacion.isalergia">Alergía a Medicamento o
                    Alimento: NO</label>
                <Checkbox id="isalergia" v-model="habitacion.isalergia" :binary="true" />
            </div>
            <div class="mb-3" v-if="habitacion.isalergia">
                <label for="alergia" class="form-label">¿Cúales? </label>
                <Chips separator="," v-model="habitacion.alergias"  class="vue-input" />
            </div>
        </div>

    </div>
    <div class="row mt-5">
        <div class="col-md-12 text-center">
            <Button type="button" label="Actualizar Habitación" title="Guardar Datos" v-on:click="guardarPaciente()"
                severity="success" :loading="loader" icon="pi pi-save">
            </button>
        </div>
    </div>
</form>